import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface BuildingPermitFeesDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const BuildingPermitFeesDescription: React.FC<BuildingPermitFeesDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [buildingPermitFeesDescription, set_buildingPermitFeesDescription] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Building Permit Fees']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Building Permit Fees': [v, b.values?.['Site Work']?.['Building Permit Fees']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={buildingPermitFeesDescription}
                />
            ) : (
                <TextBox
                    value={buildingPermitFeesDescription}
                    onChange={(value) => set_buildingPermitFeesDescription(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
